<script lang="ts">
  import { storyblokEditable } from '@storyblok/svelte';
  import { IconCard, type IconCardProps } from '@stickerapp-org/athena/Card';
  import type { IconCardBlock } from '@storyblok-types';
  import { getBackgroundClass } from '@athena-lib/Page/utils';
  import { getUrlByLinkType } from '$lib/utilities/storyblok';

  const {
    blok,
    hideDescriptionInMobile,
    useMaxHeight,
    useMinHeight,
    horizontalOnMobile,
    horizontal,
    className,
  }: {
    blok: IconCardBlock;
    hideDescriptionInMobile?: boolean;
    useMaxHeight?: boolean;
    useMinHeight?: boolean;
    horizontalOnMobile?: boolean;
    horizontal?: boolean;
    className?: string;
  } = $props();

  const badgeBackgroundColor = $derived.by(() => {
    return getBackgroundClass(blok.badgeBackground, undefined, false, false);
  });

  let iconCardProps: IconCardProps = $derived({
    ...blok,
    hideDescriptionInMobile: hideDescriptionInMobile,
    useMaxHeight: useMaxHeight,
    useMinHeight: useMinHeight,
    horizontalOnMobile: horizontalOnMobile,
    horizontal: horizontal,
    link: getUrlByLinkType(blok.linkUrl),
    title: blok.title ?? '',
    titleHeadingTag: blok.titleHeadingTag,
    description: blok.description,
    image: {
      url: blok.image?.filename ?? '',
      alt: blok.image?.alt ?? '',
    },
    class: className ?? '',
    badgeBackgroundClass: badgeBackgroundColor,
  });
</script>

<IconCard action={storyblokEditable} actionArg={blok} {...iconCardProps} />
